import { render, staticRenderFns } from "./HoldQiDetailsForm.vue?vue&type=template&id=28538e79&scoped=true&"
import script from "./HoldQiDetailsForm.vue?vue&type=script&lang=ts&"
export * from "./HoldQiDetailsForm.vue?vue&type=script&lang=ts&"
import style0 from "./HoldQiDetailsForm.vue?vue&type=style&index=0&id=28538e79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28538e79",
  null
  
)

export default component.exports